const c = {
  name: "RocketLaunch",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
	.st1{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,8c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C16,9.3,14.7,8,13,8z M12,11c0-0.6,0.4-1,1-1
			c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1C12.4,12,12,11.6,12,11z"/>
		<path class="st0" d="M13,0l7,7v7.6l4,4V27h-3.4l-2-2H14v6.1c1.9,0.3,3.5,1.5,4.3,3.2c0.5-0.2,1.1-0.3,1.7-0.3c3.3,0,6,2.7,6,6h-2
			c0-2.2-1.8-4-4-4c-0.6,0-1.2,0.2-1.8,0.4L17.1,37l-0.3-1.1c-0.4-1.3-1.5-2.4-2.8-2.7V37h-2v-3.9c-1.3,0.3-2.4,1.4-2.8,2.7L8.9,37
			l-1.1-0.5C7.2,36.2,6.6,36,6,36c-2.2,0-4,1.8-4,4H0c0-3.3,2.7-6,6-6c0.6,0,1.2,0.1,1.7,0.3c0.8-1.6,2.4-2.9,4.3-3.2V25H7.4l-2,2H2
			v-8.4l4-4V7L13,0z M20,23.6v-6.2l2,2V25h-0.6L20,23.6z M18,7.8V23h-4v-4h-2v4H8V7.8l5-5L18,7.8z M6,17.4v6.2L4.6,25H4v-5.6L6,17.4
			z"/>
		<path class="st1" d="M8,30v-3h2v3H8z"/>
		<path class="st1" d="M16,27v3h2v-3H16z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as RocketLaunch
};
